module.exports = __webpack_public_path__ + "static/media/icon-header-business.98487941.svg";